import React from "react";
import classNames from "classnames";
import * as styles from "./ProjectGrid.module.scss";

type ListItem = {
	title: string;
	percent?: string;
	id?: string | number;
};

type ProjectGridProps = {
	listItems?: ListItem[];
	number?: boolean;
	bg?: string;
	variant?: "grid-3" | "grid-4" | "grid-2";
	rows?: boolean;
	high?: boolean;
	className?: string;
};

const ProjectGrid: React.FC<ProjectGridProps> = ({
	listItems = [],
	bg = "light",
	number = false,
	variant = "grid-3",
	rows = false,
	high = false,
	className,
}) => {
	if (listItems.length === 0) return null;

	const listClasses = classNames(
		styles.list,
		styles[variant],
		{ [styles.rows]: rows },
		className
	);

	return (
		<ul className={listClasses} role="list">
			{listItems.map(({ title, percent, id }, index) => (
				<li
					key={id ?? index}
					className={classNames(
						styles.item,
						styles[bg],
						{ [styles.high]: high }
					)}
				>
					{number && (
						<div className={styles.number}>
							{String(index + 1).padStart(2, "0")}
						</div>
					)}
					{percent && <div className={styles.percent}>{percent}</div>}
					<p className={styles.listTitle}>{title}</p>
				</li>
			))}
		</ul>
	);
};

export default ProjectGrid;
